import React, { useContext, useState } from 'react'
import './ProductDisplay.css'
import { ShopContext } from '../../Context/ShopContext'

const ProductDisplay = ({ product }) => {
  // destructure first, then use product
  const [mainImg, setMainImg] = useState(product.image)
  const {addToCart} = useContext(ShopContext)

  return (
    <div className='product-display'>
      <div className="product-left">
          <div className="main-img">
            {/* use mainImg instead of product.image */}
            <img src={mainImg} alt={product.name} />
        </div>

        <div className="product-down">
          {Array.isArray(product.sideimg) &&
            product.sideimg.map((sub, index) => (
              <img
                key={index}
                src={sub}
                alt={`${product.name}-sub-${index}`}
                className="sub-img"
                onClick={() => setMainImg(sub)} // click swaps image
              />
            ))}
        </div>
      </div>

      <div className="product-right">
        <h1>{product.name}</h1>
        <h2>Product Details</h2>
        <h3>₹{product.price} Including all taxes</h3>
        <button className='product-btn' onClick={()=>addToCart(product.id)}  >ADD TO CART</button>
        <div style={{ whiteSpace: "pre-line" }} className="desc">{product.desc}</div>
      </div>
    </div>
  )
}

export default ProductDisplay
